import { render, staticRenderFns } from "./SalesOrderViewAddDeliveryForm.vue?vue&type=template&id=47d8d69f&scoped=true&"
import script from "./SalesOrderViewAddDeliveryForm.vue?vue&type=script&lang=js&"
export * from "./SalesOrderViewAddDeliveryForm.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderViewAddDeliveryForm.vue?vue&type=style&index=0&id=47d8d69f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d8d69f",
  null
  
)

export default component.exports